import * as types from './faqActionTypes';

export const getFaq = faqId => ({
  type: types.GET_FAQ_REQUEST,
  faqId,
});



// WEBPACK FOOTER //
// ./src/store/faq/faqActions.js